import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { config } from '../config';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer
} from 'recharts';
import PlotlyPlot from './Plots';

function Dashboard() {
  const navigate = useNavigate();
  const [sessionData, setsessionData] = useState(null);
  const [chartData, setChartData] = useState([]);
  const [aggregation, setAggregation] = useState('daily'); // 'daily', 'weekly', 'monthly'

  useEffect(() => {
    const raw = sessionStorage.getItem('sessionData');
    if (!raw) {
      navigate('/');
      return;
    }

    const data = JSON.parse(raw);

    if (!data.aerobic_metrics) {
      axios.get(
        `${config.getBackendUrl()}/get_aerobic_metrics`,
        { params: { athlete_id: data.platform_athlete_id } }
      ).then(res => {
        data.aerobic_metrics = res.data;
        sessionStorage.setItem('sessionData', JSON.stringify(data));
      }).catch(() => {}).finally(() => {
        setsessionData(data);
        processChartData(data.aerobic_metrics, 'Month');
      });
    } else {
      setsessionData(data);
      processChartData(data.aerobic_metrics, 'Month');
    }
  }, [navigate]);

  const processChartData = (data, aggType) => {
    if (!data || data.length === 0) {
      setChartData([]);
      return;
    }
    
    let specificData;

    if (aggType == 'Month') {
      specificData =  {
         x: data['per_month']["dates"], y: data['per_month']['aerobic_efficiency'], type: "scatter", mode: "lines+markers", name: "Monthly Aerobic Efficiency",
         hovertemplate:
         "<extra></extra>" +
         "<br><b>Aerobic Efficiency: %{y}</b>" +
         "<br><b>Month: %{x}</b>",
      }
   }
   else if (aggType == 'Week') {
      specificData = {
         x: data['per_week']["dates"], y: data['per_week']['aerobic_efficiency'], type: "scatter", mode: "lines+markers", name: "Weekly Aerobic Efficiency",
         hovertemplate:
         "<extra></extra>" +
         "<br><b>Aerobic Efficiency: %{y}</b>" +
         "<br><b>Week: %{x}</b>",
      }
   }
   else {
      specificData = {
         x: data['per_activity']["dates"], y: data['per_activity']['aerobic_efficiency'], type: "scatter", mode: "lines+markers", name: "Per Activity Aerobic Efficiency",
         hovertemplate:
         "<extra></extra>" +
         "<br><b>Aerobic Efficiency: %{y}</b>" +
         "<br><b>Date: %{x}</b>",
      }
   }

   setChartData([specificData])
      
  };

  const handleAggregationChange = (newAgg) => {
    setAggregation(newAgg);
    if (sessionData) {
      processChartData(sessionData.aerobic_metrics, newAgg);
    }
  };


  if (!sessionData) {
    return (
      <div className="center-container">
        <div className="card">
          <p className="loading">Loading...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="container">
      <div className="dashboard-header">
        <h1>Welcome, {sessionData.first_name}!</h1>
      </div>

      <div className="chart-container">
        <h2>Aerobic Efficiency</h2>

        <div className="filter-buttons">
          <button
            className={`filter-button ${aggregation === 'daily' ? 'active' : ''}`}
            onClick={() => handleAggregationChange('Activity')}
          >
            Daily
          </button>
          <button
            className={`filter-button ${aggregation === 'weekly' ? 'active' : ''}`}
            onClick={() => handleAggregationChange('Week')}
          >
            Weekly
          </button>
          <button
            className={`filter-button ${aggregation === 'monthly' ? 'active' : ''}`}
            onClick={() => handleAggregationChange('Month')}
          >
            Monthly
          </button>
        </div>

        {chartData.length > 0 ? (
          <PlotlyPlot data={chartData}/>
        ) : (
          <p style={{ textAlign: 'center', color: '#666', padding: '40px' }}>
            No data available
          </p>
        )}
      </div>
    </div>
  );
}

export default Dashboard;
